export default {"src":"/pro/_next/static/media/fartcoin.4a3d8590.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};